module.exports = __webpack_public_path__ + "static/media/unevenhip_severe_left.51f8b2d7.png";